import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { ApiKeyComponent } from './pages/api-key/api-key.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { RegisterComponent } from './pages/register/register.component';
import { SingleCustomerComponent } from './pages/single-customer/single-customer.component';
import { RelayComponent } from './pages/relay/relay.component';
import { MembershipComponent } from './pages/membership/membership.component';
import { VaultComponent } from './pages/vault/vault.component';
import { EncryptionComponent } from './pages/encryption/encryption.component';
import { CreateRelayComponent } from './pages/create-relay/create-relay.component';
import { EditRelayComponent } from './pages/edit-relay/edit-relay.component';
import { SettingsComponent } from './pages/settings/settings.component';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'organization',
    component: OrganizationComponent,
    canActivate: [AuthGuard],
  },
  { path: 'api-keys', component: ApiKeyComponent, canActivate: [AuthGuard] },
  {
    path: 'membership',
    component: MembershipComponent,
    canActivate: [AuthGuard],
  },
  { path: 'vault', component: VaultComponent, canActivate: [AuthGuard] },
  {
    path: 'encryption',
    component: EncryptionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'relay',
    children: [
      { path: '', component: RelayComponent },
      { path: 'create/:type', component: CreateRelayComponent },
      { path: 'edit/:id', component: EditRelayComponent },
    ],
  },
  { path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard] },
];
